import React from "react";
import {CardContent, CardHeader, Grid, Tab, Tabs, Button} from "@mui/material";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import {ToolbarCard} from "../../../../../Components/Cards/ToolbarCard";
import {useDispatch, useSelector} from "react-redux";
import {setModal} from "../../../../Common/App";
import {DeleteDepartmentModal} from "../Modals/DeleteDepartmentModal";
import {usePermissions} from "../../../../../Hooks/usePermissions";

export const Toolbar = ({ tab, setTab }) => {

    const dispatch = useDispatch();
    const item = useSelector((store) => store.departments.selected);
    const {hasPermission} = usePermissions();

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    const handleDelete = () => {
        dispatch(setModal({component:<DeleteDepartmentModal id={item.id} />, open:true}));
    }

    return (
        <Grid container spacing={3} sx={{mb:3}}>
            <Grid item xs={12}>
                <ToolbarCard>
                    <CardHeader
                        avatar={<AppRegistrationIcon color="secondary" fontSize="large" />}
                        title="Department"
                        subheader="Department Details"
                        action={
                            hasPermission('roster.department.delete') && (
                                <Button variant="outlined" color="error" onClick={() => handleDelete()}>
                                    Delete
                                </Button>
                            )
                        }
                    />
                    <CardContent>
                        <Tabs value={tab} onChange={handleTabChange}>
                            <Tab label="Overview" value={0} />
                            <Tab label="Users" value={1} />
                        </Tabs>
                    </CardContent>
                </ToolbarCard>
            </Grid>
        </Grid>
    )
}